import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useForm } from '@inertiajs/vue3';
    import { Role } from '@/types';
    import DialogForm from '@/components/DialogForm.vue';
    import RoleTabs from './RoleTabs.vue';
    import QueryKey from '@/enums/QueryKey';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'EditRoles',
  props: {
    role: {}
  },
  setup(__props: any) {

    const props = __props;

    const form = useForm({
        name: props.role.name,
        display_name: props.role.display_name,
        description: props.role.description,
        is_client: props.role.is_client,
        permission_ids: props.role.permissions.map((permission) => permission.id),
        role_company_ids: props.role.company.map((company) => company.id),
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DialogForm, {
    type: "update",
    form: _unref(form),
    route: _ctx.route('v2.roles.update', _ctx.role.id),
    method: "patch",
    "query-key": [_unref(QueryKey).ROLES],
    title: "roles.edit",
    "modal-size": "sm:max-w-3xl"
  }, {
    default: _withCtx(() => [
      _createVNode(RoleTabs, { form: _unref(form) }, null, 8, ["form"])
    ]),
    _: 1
  }, 8, ["form", "route", "query-key"]))
}
}

})